import { Form, Input, Grid, Select, Field } from "@alifd/next";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
const DeitDep = forwardRef((props: any, ref) => {
    const { rpcAssembly, rpcModule, options, depData, ...otherProps } = props;
    const [dataSource, setDataSource] = useState({});
    const [ops, setOps] = useState<any>([]);
    let contextComp: any = {};
    contextComp.setState = (data: any) => {
        setDataSource(data);
    }
    const Option = Select.Option;
    const fieldRef = useRef(new Field(contextComp));

    useEffect(() => {
        //   console.log(depData)
        let _ops = options;
        if (!_ops)
            _ops = [];
        setOps(_ops);
        fieldRef.current.reset();
        fieldRef.current.setValues(depData);
    }, [depData,options]);
    useImperativeHandle(ref, () => {
        let proxy: any = {};
        Object.defineProperty(proxy, 'dataSource', {
            get() {
                let result: any = fieldRef.current.getValues();
                return result;
            }
        });
        proxy.validate = () => {
            return new Promise((resolve, reject) => {
                try {
                    fieldRef.current.validate((errors: any, values: any) => {
                        resolve({ errors, values });
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        return proxy;
    }, []);
    return (
        <>
            <Form field={fieldRef.current} className="bef-custom-dep">
                <Grid.Row gutter="12">
                    <Grid.Col>
                        <Form.Item required label="部门编号" name="Id" className="custom-form-control">
                            <Input disabled />
                        </Form.Item>
                    </Grid.Col>
                    <Grid.Col>
                        <Form.Item required label="部门名称" name="Name" className="custom-form-control">
                            <Input />
                        </Form.Item>
                    </Grid.Col>
                </Grid.Row>
                <Grid.Row gutter="12">  <Grid.Col>
                    <Form.Item className="custom-form-control" label="部门负责人" name="Leader">
                        <Select
                            style={{ width: '100%' }}
                            hasClear>
                            {ops.map((op: any) => {
                                return <Option key={op.UserId} value={op.UserId}>{op.UserName}</Option>
                            })}
                        </Select>
                    </Form.Item>
                </Grid.Col>
                    <Grid.Col>
                    </Grid.Col>
                </Grid.Row>
                {/* <Grid.Row gutter="12">
                <Grid.Col>
                    <Form.Item label="上级部门" name="ParentId">
                        <Select
                            style={{ width: '100%' }}
                            hasClear>
                            {ops.map((op: any) => {
                                return <Option key={op.Id} value={op.Id}>{op.Name}</Option>
                            })}
                        </Select>
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    <Form.Item label="是否激活" name="Active">
                        <Switch autoWidth />
                    </Form.Item>
                </Grid.Col>
            </Grid.Row> */}
            </Form>
        </>

    );
});
export default DeitDep;